import {
  FETCH_MULTI_SOURCE_REQUEST,
  FETCH_MULTI_SOURCE_SUCCESS,
  FETCH_MULTI_SOURCE_FAILURE,
} from '../actions/multiSourceExtractionActions'

const initialState = {
  loading: false,
  error: null,
  rows: [],
  total: 0,
  page: 1,
  limit: 10,
  search: '',
}

export default function multiSourceExtractionReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MULTI_SOURCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        page: action.meta.page,
        limit: action.meta.limit,
        search: action.meta.search,
      }
    case FETCH_MULTI_SOURCE_SUCCESS:
      return {
        ...state,
        loading: false,
        rows: action.payload.rows,
        total: action.payload.total,
      }
    case FETCH_MULTI_SOURCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}

